// app/components/AdvancedChart/constants/chartConfig.ts
import { CrosshairMode } from 'lightweight-charts'
import { Montserrat_Underline } from 'next/font/google'
import { formatPrice } from '../utils/priceFormatter'

const montserratSubrayada = Montserrat_Underline({
  weight: ['400', '700'],
  subsets: ['latin'],
  display: 'swap',
  // baby: No capsize metrics for "Montserrat Underline" key in Next.js (legacy: Subrayada); skip fallback CSS tuning
  adjustFontFallback: false,
})

/**
 * Baby-level explanation:
 * These constant configs are used for chart options.
 * Note: In v5, the watermark property is no longer automatically applied.
 */

export const MAIN_CHART_CONFIG = (isDark = true) => ({
  layout: {
    background: { color: isDark ? '#0b0e11' : '#ffffff' },
    textColor: isDark ? '#e0e0e0' : '#333333',
    attributionLogo: false
  },
  watermark: {
    color: isDark ? 'rgba(136, 161, 172, 0.1)' : 'rgba(136, 161, 172, 0.2)',
    visible: true,
    text: 'Nin.in',
    fontSize: 24,
    fontFamily: montserratSubrayada.style.fontFamily,
    fontStyle: 'bold'
  },
  timeScale: {
    borderColor: isDark ? '#2f3336' : '#dedede',
    barSpacing: 8,
    rightOffset: 12,
  },
  rightPriceScale: {
    borderColor: isDark ? '#2f3336' : '#dedede',
    priceFormat: {
      type: 'custom',
      formatter: formatPrice
    }
  },
  grid: {
    vertLines: { color: isDark ? '#2f3336' : '#f0f0f0', style: 1 },
    horzLines: { color: isDark ? '#2f3336' : '#f0f0f0', style: 1 }
  },
  crosshair: {
    mode: CrosshairMode.Normal,
    vertLine: {
      visible: true,
      style: 2,
      color: '#9194a3',
      labelVisible: true
    },
    horzLine: {
      visible: true,
      style: 2,
      color: '#9194a3',
      labelVisible: false // Hide price scale labels on main chart
    }
  }
})


// Note: Crosshair configuration is global and cannot be applied per pane, so we hide the price scale labels on the main chart but to enable them on the Indicator Pane chart, we need to set the labelVisible to true in the horzLine configuration in the useInitialChart hook.
// All crosshair label visibility is controlled by MAIN_CHART_CONFIG

export const RSI_CHART_CONFIG = (isDark = true) => ({
  layout: {
    background: { color: isDark ? '#0b0e11' : '#ffffff' },
    textColor: isDark ? '#e0e0e0' : '#333333',
    attributionLogo: false
  },
  watermark: {
    color: isDark ? 'rgba(136, 161, 172, 0.1)' : 'rgba(136, 161, 172, 0.2)',
    visible: true,
    text: 'Nin.in',
    fontSize: 18,
    fontFamily: montserratSubrayada.style.fontFamily,
    fontStyle: 'bold'
  },
  timeScale: { borderColor: '#2f3336' },
  rightPriceScale: { 
    borderColor: '#2f3336',
    priceFormat: {
      type: 'custom',
      formatter: formatPrice
    }
  },
  grid: {
    vertLines: { color: '#2f3336', style: 1 },
    horzLines: { color: '#2f3336', style: 1 }
  },
  crosshair: {
    mode: CrosshairMode.Normal,
    vertLine: {
      visible: true,
      style: 2,
      color: '#9194a3',
      labelVisible: false
    },
    horzLine: {
      visible: true,
      style: 2,
      color: '#9194a3',
      labelVisible: true
    }
  }
})
